import { useCallback } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';
import CircleInfo from '@gef-ui/material-icons/CircleInfo';

import { bruttoTablePeriodQuickFilterSetup } from 'features/views/dashboard/statistics/constants';
import { getBruttoPeriodTableQuickFilter } from 'features/views/dashboard/statistics/selectors';
import { setBruttoPeriodQuickFilter } from 'features/views/dashboard/statistics/slice';

export const BruttoTablePeriodToggle = () => {
	const dispatch = useDispatch();
	const bruttoPeriodTableQuickFilter = useSelector(getBruttoPeriodTableQuickFilter);

	const handleBruttoPeriodToggle = useCallback(
		(quickFilterValue) => () => {
			dispatch(setBruttoPeriodQuickFilter(quickFilterValue));
		},
		[dispatch],
	);

	return (
		<Paper sx={{ p: 3, backgroundColor: (theme) => theme.palette.background[100], borderRadius: 1 }}>
			<Stack
				direction="row"
				spacing={1}
				sx={{
					alignItems: 'center',
				}}
			>
				<Typography
					variant="body2"
					color="text.secondary"
					sx={{
						fontWeight: 'medium',
					}}
				>
					{getMessage('dashboard:statistics.period')}
				</Typography>
				<Tooltip title={getMessage('dashboard:statistics.periodTooltip')}>
					<Box
						sx={{
							display: 'flex',
						}}
					>
						<CircleInfo sx={{ color: 'grey.600' }} />
					</Box>
				</Tooltip>
				{bruttoTablePeriodQuickFilterSetup.map((quickFilter) => {
					const isSelected = bruttoPeriodTableQuickFilter === quickFilter.value;

					return (
						<Chip
							sx={{
								backgroundColor: isSelected ? 'primary.main' : 'none',
								color: isSelected ? 'common.white' : 'text.primary',
								cursor: 'pointer',
							}}
							variant="outlined"
							key={quickFilter.label}
							label={getMessage(quickFilter.label)}
							onClick={handleBruttoPeriodToggle(quickFilter.value)}
							clickable={false} // to supress ripple effect
						/>
					);
				})}
			</Stack>
		</Paper>
	);
};

export default BruttoTablePeriodToggle;
